import axios from "./axios-header";

export const getDashboard = async (params = {}) => {
  const response = await axios.get("/dashboard", { params });
  return response.data;
};

// Messages ===============================================================
export const getUserMessages = async (params = {}) => {
  const response = await axios.get("/messages", { params });
  return response.data;
};

export const chatUserMessage = async (otherUserId) => {
  const response = await axios.get(`/messages/${otherUserId}`);
  return response.data;
};

export const sendUserMessage = async (data) => {
  const response = await axios.post("/messages", data);
  return response.data;
};

export const deleteUserMessage = async (otherUserId) => {
  const response = await axios.delete(`/messages/${otherUserId}`);
  return response.data;
};

// Account Request Process ==============================================
export const getReqAccountList = async (params = {}) => {
  const response = await axios.get("/request-account", { params });
  return response.data;
};

export const updateReqAccount = async (id, data) => {
  const response = await axios.put(`/request-account/${id}`, data);
  return response.data;
};

export const deleteReqAccount = async (id) => {
  const response = await axios.delete(`/request-account/${id}`);
  return response.data;
};

// Yorp Account Process ==============================================
export const getYorpAccounts = async (params = {}) => {
  const response = await axios.get("/account-yorp", { params });
  return response.data;
};

export const createYorpAccount = async (data) => {
  const response = await axios.post("/account-yorp", data);
  return response.data;
};

export const updateYorpAccount = async (id, data) => {
  const response = await axios.put(`/account-yorp/${id}`, data);
  return response.data;
};

export const deleteYorpAccount = async (id) => {
  const response = await axios.delete(`/account-yorp/${id}`);
  return response.data;
};

export const orgAccountList = async (params = {}) => {
  const response = await axios.get("/account-organization", { params });
  return response.data;
};

// Email ===============================================================
export const getSettingEmails = async (params = {}) => {
  const response = await axios.get("/setting-email-smtp", { params });
  return response.data;
};

export const createSettingEmail = async (data) => {
  const response = await axios.post("/setting-email-smtp", data);
  return response.data;
};

export const showSettingEmail = async (email) => {
  const response = await axios.get(`/setting-email-smtp/${email}`);
  return response.data;
};

export const updateSettingEmail = async (id, data) => {
  const response = await axios.put(`/setting-email-smtp/${id}`, data);
  return response.data;
};

export const deleteSettingEmail = async (id) => {
  const response = await axios.delete(`/setting-email-smtp/${id}`);
  return response.data;
};

// Advocacies ========================================================
export const getAdvocacies = async (params = {}) => {
  const response = await axios.get("/setting-advocacies", { params });
  return response.data;
};

export const createAdvocacy = async (data) => {
  const response = await axios.post("/setting-advocacies", data);
  return response.data;
};

export const updateAdvocacy = async (id, data) => {
  const response = await axios.put(`/setting-advocacies/${id}`, data);
  return response.data;
};

export const deleteAdvocacy = async (id) => {
  const response = await axios.delete(`/setting-advocacies/${id}`);
  return response.data;
};

// System Logs ========================================================
export const adminLogs = async (params = {}) => {
  const response = await axios.get("/admin-logs", { params });
  return response.data;
};

export const userLogs = async (params = {}) => {
  const response = await axios.get("/user-logs", { params });
  return response.data;
};

// Announcement ==============================================================
export const getSystemAnnounces = async (params = {}) => {
  const response = await axios.get("/setting-announces", { params });
  return response.data;
};

export const createSystemAnnounce = async (data) => {
  const response = await axios.post("/setting-announces", data);
  return response.data;
};

export const updateSystemAnnounce = async (id, data) => {
  const response = await axios.put(`/setting-announces/${id}`, data);
  return response.data;
};

export const deleteSystemAnnounce = async (id) => {
  const response = await axios.delete(`/setting-announces/${id}`);
  return response.data;
};

// Announcement ==============================================================
export const getOrganizationList = async (params = {}) => {
  const response = await axios.get("/organizations", { params });
  return response.data;
};

export const updateOrganizationInfo = async (id, data) => {
  const response = await axios.put(`/organizations/${id}`, data);
  return response.data;
};

export const updateOrganizationStatus = async (data) => {
  const response = await axios.post("/organizations", data);
  return response.data;
};

export const deleteOrganization = async (id) => {
  const response = await axios.delete(`/organizations/${id}`);
  return response.data;
};


// Profie =========================================================
export const updateImgProfileSetting = async (id, data) => {
  data.append('_method', 'PUT');

  return await axios.post(`/profile-setting/${id}`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const updateInfoProfileSetting = async (data) => {
  const response = await axios.post("/profile-setting", data);
  return response.data;
};
export const updatePassProfileSetting = async (data) => {
  const response = await axios.post("/change-password", data);
  return response.data;
};

export const updateNotificationSettings = async (data) => {
  const response = await axios.post("/update-notifications", data);
  return response.data;
};

// Resolution Process ==============================================
export const getCertificateResos = async (params = {}) => {
  const response = await axios.get("/certificate-resolution", { params });
  return response.data;
};

export const createCertificateReso = async (data) => {
  const response = await axios.post("/certificate-resolution", data);
  return response.data;
};

export const updateCertificateReso = async (id, data) => {
  const response = await axios.put(`/certificate-resolution/${id}`, data);
  return response.data;
};

export const deleteCertificateReso = async (id) => {
  const response = await axios.delete(`/certificate-resolution/${id}`);
  return response.data;
};

// Notification List =============================================================
export const getCountUnreads = async (type) => {
  const response = await axios.get(`/notifications/${type}`);
  return response.data;
}; 

export const getNotificationList = async (params = {}) => {
  const response = await axios.get("/notifications", { params });
  return response.data;
};

export const updateNotificationStatuses = async (data) => {
  const response = await axios.post("/notifications/mark-as-read", data);
  return response.data;
};

export const markAllAsRead = async () => {
  const response = await axios.post("/notifications/mark-all-read");
  return response.data;
};

export const deleteNotification = async (id = null, data = null) => {
  if (id) {
    const response = await axios.delete(`/notifications/${id}`);
    return response.data;
  } else if (data) {
    const response = await axios.delete("/notifications", { data });
    return response.data;
  }
};